import { FC, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Course } from '../../../models/Course';
import Form from 'react-bootstrap/Form';
import CourseEndpoint from '../../../../api/endpoint/CourseEndpoint';
import { RichTextEditor } from '../../widget/RichText';

interface CourseProps {
    course: Course;
    show: boolean;
    onHide: () => void;
    isNew: boolean;
    initiateReload: () => void;
}

export const CourseModal: FC<CourseProps> = ({course, show, onHide, isNew, initiateReload}) => {
    const [title, setTitle] = useState<string>(course.title);
    const [description, setDescription] = useState<string>(course.description);
    
    const [validated, setValidated] = useState(false);

    const handleSubmit = async (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if(form.checkValidity() === true) {
            event.preventDefault();
            if(isNew){
                await handleCreateNew();
            } else {
                await handleUpdate();
            }
            initiateReload();
            onHide();
        }
        
        setValidated(true);
    };

    const handleCreateNew = async () => {
        const createResult = await CourseEndpoint.Create({title: title, description: description});

        if(!createResult){
            console.error('Error creating course');
        }
    };

    const handleUpdate = async () => {
        const updatedTitle = title !== course.title ? title : undefined;
        const updatedDescription = description !== course.description ? description : undefined;

        const updateResult = await CourseEndpoint.Update({course_id: course.course_id, title: updatedTitle, description: updatedDescription});

        if(!updateResult){
            console.error('Error updating course');
        }
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="course-title"
            centered
            backdrop={true}
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="course-title">
                    {!isNew &&
                        <>Edit {course.title}</>
                    }
                    {isNew && 
                        <>Add Course</>
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="course-title">
                        <Form.Label>Title</Form.Label>
                        <Form.Control value={title} onChange={(e:any) => setTitle(e.target.value)} type="text" required/>
                        <Form.Control.Feedback type="invalid">Please enter a title.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="course-description">
                        <p>Description</p>
                        <RichTextEditor
                            
                            value={description} 
                            onChange={setDescription}
                            placeholder="Course description"
                        />
                    </Form.Group>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={onHide}>Close</Button>
                        <Button variant="primary" className="text-light" type="submit">Submit</Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    )
}